/**
 * Wizard step object.
 *
 * Has a onNextClick and onBackClick method that perform actions and return next/previous state.
 *
 * @param {string} id Logical name of the wizard step as referenced in the template.
 * @param {string} heading The text to display as the heading for the step
 * @param {string} nextButtonText The button text to display for the "next" button
 * @param {WizardStep|boolean} [previousState] Previous state or false if it does not exist.
 * @constructor
 */
function WizardStep(id, heading, nextButtonText, previousState) {
  this.id = id;
  this.heading = heading;
  this.nextButtonText = nextButtonText;
  this.onNextClick = function() {
    throw new Error(
      'Wizard step ' + id + ' does not have a next method defined!'
    );
  };
  if (previousState) {
    this.onBackClick = function() {
      return previousState;
    };
  }
}

angular
  .module('cfn')
  .controller('fieldImportWizardController', fieldImportWizardController);

fieldImportWizardController.$inject = [
  'CfnHttpInterceptor',
  '$q',
  '$rootScope',
  '$scope',
  'dialog',
  '$injector',
  '$resource',
  '$filter',
  'enumFilter',
  'unitConverter',
  'userSettingsService',
  'fieldImportWizardService',
  'fields.fieldService',
  'farmService',
  'tracker'
];
function fieldImportWizardController(
  CfnHttpInterceptor,
  $q,
  $rootScope,
  $scope,
  dialog,
  $injector,
  $resource,
  $filter,
  enumFilter,
  unitConverter,
  userSettingsService,
  fieldImportWizardService,
  fieldService,
  farmService,
  tracker
) {
  var controller = this;
  var i18n = $filter('i18n');
  var registrationCountry = userSettingsService.getIsoCountryEnum();
  var hasDataProvider = ['DEU', 'FRA', 'AUT', 'CHE'].indexOf(userSettingsService.getIsoCountryEnum()) !== -1;
  controller.featuresToImport = null;
  controller.showFeaturesName = true;
  controller.featuresStyle = createDynamicStyles();

  controller.popupTitle = i18n('fe.core.wizards.fieldImport.title');

  controller.popupShow = true;

  controller.uploadHelps = {
    DEU: {
      i18n: 'fe.shapefile.upload.wizardText.uploadDeHelp'
    },
    FRA: {
      i18n: 'fe.shapefile.upload.wizardText.uploadFrHelp'
    },
    CHE: {
      i18n: 'fe.shapefile.upload.wizardText.uploadHelpCH'
    },
    default: {
      i18n: 'fe.shapefile.upload.wizardText.uploadHelp'
    }
  };
  if (controller.uploadHelps[registrationCountry]) {
    controller.uploadHelp = controller.uploadHelps[registrationCountry];
  } else {
    controller.uploadHelp = controller.uploadHelps.default;
  }

  var popupStateSelectionHelpKeys = {
    CHE: 'fe.shapefile.upload.wizardText.stateSelectionHelpCH',
    default: 'fe.shapefile.upload.wizardText.stateSelectionHelp'
  };
  controller.popupStateSelectionHelpKey = getI18nKey(popupStateSelectionHelpKeys)

  var popupErrorKeys = {
    CHE: 'fe.fieldimport.upload.errorCH',
    default: 'fe.fieldimport.upload.error'
  };
  controller.popupErrorKey = getI18nKey(popupErrorKeys);

  controller.selectedCoordinateSystem = null;

  function getI18nKey(keys) {
    if (keys[registrationCountry]) {
        return keys[registrationCountry];
    } else {
        return keys['default'];
    }
  };

  controller.changeCrs = function() {
    controller.verifyUserInputNecessary();
    if (
      controller.selectedCoordinateSystem == null &&
      controller.sridByProviderName.hasOwnProperty(controller.dataProvider)
    ) {
      controller.selectedCoordinateSystem =
        controller.sridByProviderName[controller.dataProvider];
    }
    updateSample();
  };

  controller.isPreviewVisible = function() {
    return (
      controller.dataProvider !== 'NONE' &&
      controller.selectedCoordinateSystem != null
    );
  };

  controller.isCoordinateSelectionVisible = function() {
    if (controller.sridByProviderName != null) {
      var srid = controller.sridByProviderName[controller.dataProvider];
      return (
        (controller.shapeSrid !== srid ||
          !(controller.shapeSrid in controller.sridByProviderName)) &&
        Object.keys(controller.sampleGeometry || {}).length > 1
      );
    }
    return false;
  };
  
  function createDynamicStyles() {
    let stroke = new ol.style.Stroke({
      color: '#494949',
      width: 2
    });
    let text = new ol.style.Text({
      scale: 1.3,
      fill: new ol.style.Fill({
        color: '#000000'
      }),
      stroke: new ol.style.Stroke({
        color: '#ffffff',
        width: 2.5
      })
    });

    let styles = {
      newField: {
        text,
        stroke,
        fill: new ol.style.Fill({
          color: 'rgba(141, 186, 119, 0.8)'
        })
      },
      existing: {
        text,
        stroke,
        fill: new ol.style.Fill({
          color: 'rgba(231, 173, 0, 0.8)'
        })
      },
      conflict: {
        text,
        stroke,
        fill: new ol.style.Fill({
          color: 'rgba(227, 87, 64, 0.8)'
        })
      },
      sample: {
        style: new ol.style.Style({
          stroke,
          fill: new ol.style.Fill({
            color: 'rgba(228, 227, 217, 0.8)'
          })
        })
      }
    };
    const stateToStyle = {
      EXISTS: styles.existing,
      NEW: styles.newField,
      CONFLICT: styles.conflict
    };
    return (feature, resolution) => {
      let properties = feature.getProperties();
      if (properties.isSample) return styles.sample.style;
      if (properties.state in stateToStyle) {
        let styleInfo = stateToStyle[properties.state];
        let fieldStyle = new ol.style.Style(styleInfo);
        let showText = controller.showFeaturesName && resolution < 10;
        let text = showText
          ? `${properties.name}\n(${
              enums.FieldImportStateEnum[properties.state]
            })`
          : '';

        fieldStyle.getText().setText(text);
        return fieldStyle;
      }

      //do we need a fall back?
      return styles.sample.style;
    };
  }

  // ---------------------------- # File uploader configuration # ------------------------------------
  var uploadId = null;

  function getUploadId() {
    return uploadId;
  }

  function updateSample() {
    if (
      controller.sampleGeometry &&
      angular.isNumber(controller.selectedCoordinateSystem)
    ) {
      //backend should properly return a json, until then this will do
      let geom = controller.sampleGeometry[controller.selectedCoordinateSystem];
      if (angular.isDefined(geom)){
        controller.sampleFeature = {
          type: 'Feature',
          properties: { isSample: true },
          geometry: JSON.parse(geom)
        };
      } else {
          if (controller.sampleGeometry) {
              if (Object.keys(controller.sampleGeometry).length == 0) {
                  controller.error = $filter('i18n')(
                      'fe.fieldimport.upload.nogeom',
                      'No geometries found.'
                  );
              }
          }
          controller.sampleFeature = undefined;
      }
    } else {
      controller.sampleFeature = undefined;
    }
  }

  // handle timeouts while importing by telling the user to try with a smaller file.
  _.each(
    ['upload/finish', 'import/validate', 'import/processing', 'import/mapping'],
    function(path) {
      CfnHttpInterceptor.configureInterception(
        '/365FarmNet/rest/fieldimport/' + path,
        null,
        CfnHttpInterceptor.createConfiguration({ doNotThrowError: true })
      );
    }
  );

  var handleError = function(errorResponse) {
    if (errorResponse.status === 504) {
      controller.error = $filter('i18n')(
        'fe.shapefile.upload.error.serverTimeout',
        'The server is taking too long for the processing. Try uploading a smaller file.'
      );
    } else if (errorResponse.status === 503) {
      controller.error = $filter('i18n')(
        'fe.common.error.connection',
        'Connection failure.'
      );
    } else {
      // TODO: handle it properly
      if (errorResponse.data && errorResponse.data.key) {
        controller.error = $filter('i18n')(
          errorResponse.data.key,
          errorResponse.data.messageCode
        );
      } else {
        controller.error = $filter('i18n')(
          'fe.shapefile.upload.error.process.mapping',
          'An error has occurred while reading the shapefile.'
        );
      }
    }
    track('ERROR');
    app.hideLoader();
    goToFirstStep();
  };

  var ShapeImport = $resource(
    '/365FarmNet/rest/fieldimport/:action/:restAction:id',
    {},
    {
      getMapping: {
        method: 'POST',
        params: {
          action: 'import',
          restAction: 'mapping'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          uploadId: getUploadId
        }
      },
      processMapping: {
        method: 'POST',
        params: {
          action: 'import',
          restAction: 'validate'
        },
        headers: { uploadId: getUploadId }
      },
      /*processSelection: {
            method: 'POST',
            params: {
                action: 'import',
                restAction: 'processing'
            },
            headers: {uploadId: getUploadId}
        },*/

      initUpload: {
        method: 'POST',
        params: {
          action: 'upload',
          restAction: 'init'
        },
        headers: { uploadId: getUploadId }
      },
      deleteUploadedFile: {
        method: 'DELETE',
        params: { action: 'upload' },
        headers: { uploadId: getUploadId }
      },
      finishUpload: {
        method: 'GET',
        params: {
          action: 'upload',
          restAction: 'finish'
        },
        headers: { uploadId: getUploadId }
      },
      cleanUpload: {
        method: 'POST',
        params: {
          action: 'upload',
          restAction: 'clean'
        },
        headers: { uploadId: getUploadId }
      }
    }
  );
  var uploader;
  // get the upload id from server to define this conversation
  ShapeImport.initUpload(function(response) {
    uploadId = response.uploadId;
    uploader = fieldImportWizardService.initUploader(uploadId);

    uploader.bind('FilesAdded', function(files) {
      $scope.$apply(function() {
        enableNextButton();
        files.forEach(function(file) {
          controller.uploadedFiles[file.name] = {};
          controller.shapeFileNames.push(file.name);
        });
        checkSelectedFiles();
      });
    });

    uploader.bind('BeforeUpload', function() {
      checkSelectedFiles();
    });

    uploader.bind('Error', function(err) {
      $scope.$apply(function() {
        controller.uploading = false;
        if (err.code === -600) {
          controller.error = $filter('i18n')(
            'fe.core.wizards.isoImport.fileTooBig',
            'The file size exceeds the limit of {0}.',
            '5 MByte'
          );
        } else if (err.code === -601) {
          controller.error = $filter('i18n')(
            controller.popupErrorKey
          );
        } else if (err.code === -602) {
          // Duplicate file added - no error displayed to the user.
        } else {
          controller.error = $filter('i18n')(
            'fe.core.wizards.isoImport.generalError',
            'An error occurred.'
          );
        }
        app.hideLoader();
      });
    });

    uploader.bind('FileUploaded', function(allFiles, file, response) {
      $scope.$apply(function() {
        if (file) {
          controller.uploadedFiles[file.name].done = true;
          controller.uploadedFiles[file.name].response = response.response;
        }
        uploadFileChange();
      });
    });

    uploader.bind('FilesRemoved', function(files) {
      enableNextButton();
      _.each(files, function(file) {
        delete controller.uploadedFiles[file.name];
        controller.selectedCoordinateSystem = null;
        delete controller.supportedCrs;
        ShapeImport.deleteUploadedFile({ restAction: file.name });
      });
      if (checkSelectedFiles()) {
        uploadFileChange();
      }
    });

    function uploadFileChange() {
      var allUploaded = _.chain(controller.uploadedFiles)
        .pluck('done')
        .all()
        .value();
      if (allUploaded) {
        controller.prepareMapping();
        controller.processing = false;
      }
    }
  }, handleError);

  // ---------------------------------- # Wizard steps configuration # ----------------------------------
  // Wizard steps: upload > stateselection > mapping > import > report
  var steps = [];
  var defaultNextButtonText = i18n('fe.common.nextLabel', 'Weiter');
  var uploadStep = new WizardStep(
    'upload',
    i18n('fe.shapefile.upload.wizardText.upload', 'File upload'),
    defaultNextButtonText,
    false
  );
  uploadStep.onNextClick = function() {
    if (uploader.hasFilesToUpload()) {
      controller.dataProvider = 'NONE';
      controller.processing = true;
      app.showLoader();
      uploader.start();
    }

    if (hasDataProvider) {
      stateSelectionStep.init();
      updateSample();
      return stateSelectionStep;
    }

    disableNextButton();
    return mappingStep;
  };

  var stateSelectionStep = new WizardStep(
    'stateselection',
    i18n('fe.shapefile.upload.wizardText.stateselection', 'Provider'),
    defaultNextButtonText
  );
  stateSelectionStep.onNextClick = function() {
    return mappingStep;
  };
  stateSelectionStep.onBackClick = function() {
    stateSelectionStep.init();
    controller.userInputNecessary = false;

    return uploadStep;
  };

  var mappingStep = new WizardStep(
    'mapping',
    i18n('fe.shapefile.upload.wizardText.mapping', 'Assignment'),
    defaultNextButtonText
  );
  mappingStep.onNextClick = function() {
    var mappingResult = {};
    for (var farmNetAttribute in controller.shapeFileAttributeMapping) {
      if (controller.shapeFileAttributeMapping[farmNetAttribute]) {
        mappingResult[farmNetAttribute] =
          controller.shapeFileAttributeMapping[farmNetAttribute].name;
      }
    }
    controller.prepareSelect(mappingResult);
    return selectStep;
  };
  mappingStep.onBackClick = function() {
    if (hasDataProvider) {
      return stateSelectionStep;
    } else {
      return uploadStep;
    }
  };

  var selectStep = new WizardStep(
    'select',
    i18n('fe.shapefile.upload.wizardText.select', 'Selection'),
    defaultNextButtonText,
    mappingStep
  );
  selectStep.onNextClick = function() {
    controller.preparePreview();
    controller.prepareReport();
    return previewStep;
  };
  selectStep.onBackClick = function() {
    if (!hasDataProvider || controller.dataProvider === undefined) {
      // if the user is not in Germany or has selected manual mapping we return them to the mapping step.
      return mappingStep;
    } else {
      return stateSelectionStep;
    }
  };

  var previewStep = new WizardStep(
    'preview',
    i18n('fe.shapefile.upload.wizardText.preview', 'Preview'),
    defaultNextButtonText,
    selectStep
  );
  previewStep.onNextClick = function() {
    controller.preparePreview();
    return reportStep;
  };

  var reportStep = new WizardStep(
    'report',
    i18n('fe.shapefile.upload.wizardText.report', 'Report'),
    i18n('fe.common.apply', 'Übernehmen'),
    previewStep
  );
  reportStep.onNextClick = function() {
    controller.commitSelection();
    return false;
  };

  steps.push(uploadStep);
  if (hasDataProvider === true) {
    steps.push(stateSelectionStep);
  }
  steps.push(mappingStep);
  steps.push(selectStep);
  steps.push(previewStep);
  steps.push(reportStep);

  $scope.onClick = angular.noop;

  // Allgemein
  controller.gesImportArea = 0;
  // deprecated
  controller.error = ' ';
  controller.warning = undefined;
  controller.processing = false;
  controller.userInputNecessary = false;
  controller.wizardSteps = [];

  // Mapping for the cfnWizard directives. Map the objects from above to the expected values by the directive.
  controller.wizardStepsText = {};
  steps.forEach(function(step) {
    controller.wizardSteps.push(step.id);
    controller.wizardStepsText[step.id] = step.heading;
  });
  var currentWizardStepObject;

  function goToFirstStep() {
    currentWizardStepObject = uploadStep;
    controller.currentWizardSteps = { upload: true };
    controller.wizardStep = 'upload';
  }

  goToFirstStep();

  // Step 1 ShapeUpload
  controller.shapeFileNames = [];
  controller.uploadedFiles = {};
  controller.registrationCountry = registrationCountry;

  controller.shapeSrid = 0;
  controller.sampleGeometry = '';
  controller.dataProvider = 'NONE';

  // Step 3 Mapping
  // map of farmNetAttributeName -> array of possible shape file mappings
  controller.mapping = null;
  // contains a mapping of farmNetAttributeName -> element of controller.mapping[farmNetAttributeName] that the user selected
  controller.shapeFileAttributeMapping = {};
  controller.supportedDataProvider = {};
  controller.sridByProviderName = {};
  controller.crsBySrid = {};
  controller.availableUnits = {};
  controller.areaUnit = null;
  controller.importType = null;
  controller.farm = null;
  farmService.getFarms().then((response) => {
  	controller.farms = response.data.list;
  	controller.farm = controller.farms.length === 1 ? controller.farms[0].id : null;
  });

  // Step 4 Select
  controller.filteredData = [];

  // Step 6 Report
  controller.importResult = {};

  stateSelectionStep.init = function() {
    controller.verifyUserInputNecessary();
  };

  /**
   * Remove a file both from the controller instance and the uploader instance (by name).
   * @param fileName The name of the file to remove, e.g. "BLE_070042422.dbf".
   */
  controller.removeShapeFile = function(fileName) {
    var indexOfFileName = controller.shapeFileNames.indexOf(fileName);
    controller.shapeFileNames.splice(indexOfFileName, 1);
    uploader.removeFile(fileName);
  };

  controller.nextAction = function() {
    var nextStep = currentWizardStepObject.onNextClick();
    if (nextStep) {
      currentWizardStepObject = nextStep;
      controller.currentWizardSteps[nextStep.id] = true;
      controller.wizardStep = nextStep.id;
    }
  };

  controller.previousAction = function() {
    enableNextButton();
    var currentState = currentWizardStepObject;
    var previousState = currentState.onBackClick();
    if (previousState) {
      delete controller.currentWizardSteps[currentState.id];
      currentWizardStepObject = previousState;
      controller.wizardStep = previousState.id;
    }
  };

  controller.nextLabel = function() {
    return currentWizardStepObject.nextButtonText;
  };

  controller.nextDisabled = function() {
    return (
      controller.processing || controller.error || controller.userInputNecessary
    );
  };

  controller.previousDisabled = function() {
    return controller.processing;
  };

  controller.close = function(action) {
    ShapeImport.cleanUpload();
    controller.popupShow = false;
    dialog.close({ action: action });
  };

  function getMessageList(messages) {
    for (var i in messages) {
      if (messages.hasOwnProperty(i)) {
        var message = messages[i];
        if (message.type === 'ERROR') {
          // Es kann nur einen geben
          controller.error = i18n(message.key, message.messageCode);
        }
      }
    }
  }

  // Prepare Step 2: Provider Selection
  controller.prepareMapping = function() {
    ShapeImport.finishUpload(function(response) {
      var messages = response.messages;
      getMessageList(messages);
      if (response.fileSrid) {
        controller.shapeSrid = response.fileSrid;
      }
      if (response.sampleGeometry) {
        controller.sampleGeometry = response.sampleGeometry;
      }
      if (response.importType) {
        controller.importType = response.importType;
      }
      if (response.supportedDataProvider) {
        controller.supportedDataProvider = response.supportedDataProvider;
        controller.supportedDataProvider.forEach(function(provider) {
          var providerName = provider.providerName;
          controller.sridByProviderName[providerName] = provider.epsg;
        });
        if (
          controller.supportedDataProvider.length === 1 &&
          (controller.importType === 'XML' || controller.importType === 'GML')
        ) {
          // only one option, so no user interaction is
          // necessary.
          controller.userInputNecessary = false;
          controller.dataProvider =
            controller.supportedDataProvider[0].providerName;
          controller.selectedCoordinateSystem =
            controller.supportedDataProvider[0].epsg;
        }
      }
      if (response.supportedCrs) {
        controller.supportedCrs = response.supportedCrs;
        controller.supportedCrs.forEach(function(crs) {
          var srid = crs.epsg;
          controller.crsBySrid[srid] = crs.name;
        });
        if (controller.crsBySrid.hasOwnProperty(controller.shapeSrid)) {
          // controller.selectedCoordinateSystem = controller.crsBySrid[controller.shapeSrid];
          controller.selectedCoordinateSystem = controller.shapeSrid;
        }
      }
      if (controller.sampleGeometry.hasOwnProperty('0')) {
        var item = {
          name: i18n(
            'fe.core.wizards.fieldimport.fromImportFile',
            'From import file'
          ),
          epsg: 0
        };
        controller.supportedCrs.unshift(item);
        controller.selectedCoordinateSystem = 0;
      }

      if (response.message) {
        ShapeImport.getMapping(function(response) {
          controller.mapping = response.mapping;
          controller.availableUnits = response.availableUnits;
          controller.areaUnit = response.areaUnit;
          var messages = response.messageList;
          getMessageList(messages);
          app.hideLoader();
        }, handleError);
        updateSample();
      }
    }, handleError);
  };

  /**
   * Calculate sample values to display to the user for a selected attribute in the shape file.
   *
   * @param {string} farmNetAttributeName The name of the farmnet attribute to calculate the samples for.
   * @returns {string} 0, 1 or 2 aggregated example values. E.g. "456, 1312" for the farmedArea.
   */
  controller.attributeSamples = function(farmNetAttributeName) {
    var selectedShapeFileMapping =
      controller.shapeFileAttributeMapping[farmNetAttributeName];
    if (
      selectedShapeFileMapping &&
      selectedShapeFileMapping.samples.length > 0
    ) {
      return selectedShapeFileMapping.samples
        .slice(0, 2) // only use a maximum of two elements as samples
        .reduce(function(aggregator, sample) {
          return aggregator + ', ' + sample;
        });
    } else {
      return '';
    }
  };

  /**
   * Handler called when the user updates the mapping of FarmNet attributes to shape file attributes.
   */
  controller.onUpdateMapping = function() {
    controller.error = validateDuplicateMappings();
  };

  function checkSelectedFiles() {
    var result = fieldImportWizardService.checkFiles();

    controller.filemethod = result.getType();

    if (!result.isValid()) {
      var message = ' ';
      var type = result.getType();
      if (!type) {
        // no files selected -> initial state
      } else if (type === 'SHP') {
        message = $filter('i18n')(
          'fe.shapefile.upload.error.invalidFileCount',
          'At least one *.shx, one *.dbf file and one *.shp file with identical names need to be selected.'
        );
      } else if (type === 'XML') {
        message = $filter('i18n')(
          'fe.fieldimport.xml.error.tooManyFiles',
          'Please select only <b>one</b> XML/GML file.'
        );
      } else if (type === 'SHP,XML') {
        message = $filter('i18n')(
          'fe.fieldimport.upload.error',
          'You must either select data in shapefile format' +
            ' (*.shx, *.dbf, *.shp) or in XML/GML format.'
        );
      }
      controller.error = message;
      return false;
    }
    return true;
  }

  function disableNextButton() {
    controller.error = ' ';
  }

  function enableNextButton() {
    controller.error = null;
    controller.userInputNecessary = false;
  }

  function validateDuplicateMappings() {
    var usedMappings = [];
    for (var farmNetAttributeName in controller.shapeFileAttributeMapping) {
      if (
        controller.shapeFileAttributeMapping[farmNetAttributeName] &&
        controller.shapeFileAttributeMapping[farmNetAttributeName].name
      ) {
        var shapeAttributeName =
          controller.shapeFileAttributeMapping[farmNetAttributeName].name;
        if (usedMappings.indexOf(shapeAttributeName) > -1) {
          return i18n(
            'fe.shapefile.upload.mapping.assignAttribute',
            'Attributes cannot be assigned more than once'
          );
        } else if (shapeAttributeName) {
          // if there was no mapping for the FarmNet attribute we don't add `undefined` to the list of used mappings.
          usedMappings.push(shapeAttributeName);
        }
      }
    }
    return undefined;
  }

  controller.isDataProviderSelectionVisible = function() {
    return (
      controller.processing === false &&
      controller.wizardStep === 'stateselection'
    );
  };

  // Prepare Step 4: Select
  controller.selectionChange = function(selected) {
    if (angular.isObject(selected) && Object.keys(selected).length > 0) {
      enableNextButton();
    } else {
      disableNextButton();
    }
  };
  controller.prepareSelect = function(shapeFileAttributeMapping) {
    app.showLoader();
    ShapeImport.processMapping(
      {
        mappingresult: shapeFileAttributeMapping,
        // "" translated to undefined because the REST Endpoint expects that rather
        dataProvider:
          controller.dataProvider === '' ||
          controller.dataProvider === 'NONE' ||
          controller.dataProvider === 'MANUAL'
            ? undefined
            : controller.dataProvider,
        srid:
          controller.selectedCoordinateSystem != null
            ? controller.selectedCoordinateSystem
            : controller.shapeSrid,
        areaUnit: controller.areaUnit
      },
      function(response) {
        if (response.areaUnit) {
          controller.areaUnit = response.areaUnit;
        }

        for (var i in response.messages) {
          if (response.messages[i].type === 'ERROR') {
            // Es kann nur einen geben
            controller.error = $filter('i18n')(
              response.messages[i].key,
              response.messages[i].messageCode
            );
          } else if (response.messages[i].type === 'WARNING') {
            controller.warning = $filter('i18n')(
              response.messages[i].key,
              response.messages[i].messageCode
            );
          }
        }

        controller.importResult = response;
        controller.filteredData = _.each(
          controller.setDefaultNameWhenNameAttributeIsNotSet(response.states),
          function(fieldEntry) {
            if (fieldEntry.type === 'STRIP') {
              fieldEntry.name +=
                ' (' + i18n('fe.core.wizards.fieldimport.strip', 'strip') + ')';
            }
          }
        );

        // enableNextButton();
        disableNextButton(); // until something is selected
        app.hideLoader();
      },
      handleError
    );
  };

  controller.verifyUserInputNecessary = function() {
    controller.userInputNecessary =
      controller.dataProvider === 'NONE' ||
      (controller.dataProvider === 'MANUAL' &&
        controller.selectedCoordinateSystem === null) ||
      (controller.dataProvider === '' &&
        controller.selectedCoordinateSystem === null &&
        controller.shapeSrid === 0);
  };

  controller.setDefaultNameWhenNameAttributeIsNotSet = function(states) {
    var c = 1;
    angular.forEach(states, function(value, key) {
      if (!value.name || $.trim(value.name) === '') {
        value.name = i18n(
          'fe.core.wizards.fieldimport.fieldName.unknown',
          'Field No. {0}',
          value.number ? value.number : c
        );
      }
      c++;
    });
    return states;
  };
  /**
   * @returns {boolean} true if the dataProvider the user selected (if they did) could not be mapped at all to fields.
   */
  controller.dataProviderMappingWasUnsuccessful = function() {
    return (
      angular.isDefined(controller.dataProvider) &&
      controller.importResult.total !== undefined &&
      controller.importResult.total === controller.importResult.failed
    );
  };

  /**
   * Called at init-time of grid.
   */
  controller.gridInit = function(gridController, gridScope) {
    controller.gridCtrl = gridController;
    controller.gridScope = gridScope;
  };

  /**
   * Called after the model has changed. Ensures that selection is updated.
   */
  controller.afterupdatemodel = function() {
    if (controller.gridCtrl) {
      controller.gridCtrl.clearSelection();
      controller.filteredData.forEach(function(data) {
        if (data.selected) {
          data.$cfngrid_selected = false;
          controller.gridCtrl.setSelectedRowById(data.id);
        }
      });
      controller.gridCtrl.refresh();
      controller.gridScope.updateSelectionView();
    }
  };

  controller.updateSelected = function(value, rowData, event) {
    // FIXME: Remove this for block if it is not needed (used to calculate area)
    if (controller.gridCtrl) {
      rowData.$cfngrid_selected = false;
      controller.gridCtrl.setSelectedRowById(rowData.id);
      controller.gridCtrl.refresh();
      controller.gridScope.updateSelectionView();
    }
    enableNextButton();
  };

  // Prepare Step 5: Vorschau
  controller.preparePreview = function() {
    if (!controller.filteredData) {
      return;
    }
    let features = [];
    controller.filteredData
      .filter(function(dat) {
        return dat.geom !== undefined && dat.$cfngrid_selected === true;
      })
      .forEach(function(dat) {
        var geometry = JSON.parse(dat.geom);

        //NEW
        features.push({
          type: 'Feature',
          properties: {
            state: dat.state,
            number: dat.number,
            name: dat.name,
            farmedArea: dat.farmedArea,
            fieldId: dat.fieldId
          },
          geometry: geometry
        });
      });
    if (features.length > 0) {
      controller.featuresToImport = {
        type: 'FeatureCollection',
        features: features
      };
    }
  };

  // In Step 5: preparing for step 6
  controller.prepareReport = function() {
    // NEW, EXISTS, FAILED, CONFLICT
    controller.importResult.created = 0;
    controller.importResult.exist = 0;
    controller.importResult.failed = 0;
    controller.filteredData.forEach(function(data) {
      if (data.$cfngrid_selected) {
        data.selected = true;
        if (data.state === 'NEW' || data.state === 'CONFLICT') {
          controller.importResult.created += 1;
        } else if (data.state === 'EXISTS') {
          controller.importResult.exist += 1;
        } else if (data.state === 'FAILED') {
          controller.importResult.failed += 1;
        }
      } else {
        data.selected = false;
      }
    });
  };

  // sends slices to the backend.
  function sendData(dataToSend, actualPos, nextSliceLength) {
    return function() {
      controller.processProgress =
        (actualPos + nextSliceLength) / dataToSend.length * 100;

      let toCreate = [];
      let toUpdate = [];
      let allPromises = [];
      dataToSend
        .slice(actualPos, actualPos + nextSliceLength)
        .forEach(field => {
          let model = {
            id: field.fieldId,
            name: field.name,
            number: field.number,
            officialId: field.officialId,
            administrativeRegion: field.administrativeRegion,
            farmableAreaInHa: field.farmedArea,
            geometry: JSON.parse(field.geom) || null,
            farm: {id: controller.farm}
          };
          if (field.state === 'NEW' || field.state === 'CONFLICT' || field.state === 'FAILED') {
            toCreate.push(model);
          } else {
            toUpdate.push(model);
          }
        });
      if (toUpdate.length > 0) {
        allPromises.push(fieldService.update(toUpdate));
      }
      if (toCreate.length > 0) {
        allPromises.push(fieldService.create(toCreate, true));
      }
      return $q.all(allPromises);
    };
  }

  // Last Step: Finish
  controller.commitSelection = function() {
    disableNextButton();
    const maxBatchSize = 100;
    const minBatchSize = 10;
    const desiredNumberOfBatches = 10;

    var filteredData = controller.filteredData.filter(e => e.selected);
    var fdSize = filteredData.length;
    var nextSliceLength = Math.ceil(
      Math.min(
        Math.max(fdSize / desiredNumberOfBatches, minBatchSize),
        maxBatchSize
      )
    );
    var actualPos;

    var myPromise = $q.when();
    for (actualPos = 0; actualPos < fdSize; ) {
      nextSliceLength =
        actualPos + nextSliceLength < fdSize
          ? nextSliceLength
          : fdSize - actualPos;
      myPromise = myPromise.then(
        sendData(filteredData, actualPos, nextSliceLength)
      );
      actualPos = actualPos + nextSliceLength;
    }

    myPromise
      .then(function() {
        controller.close('success');
        track('SUCCESS');
      })
      .catch(function(fault) {
        console.error($filter('i18n')(fault));
        controller.error = $filter('i18n')(fault);
        handleError(fault);
      })
      .finally(function() {
        controller.processProgress = undefined;
      });
  };

  function track(action) {
    try {
      var errorEventString =
        controller.dataProvider + '_' + controller.filemethod;
      var filedCount = (controller.filteredData || []).length;
      tracker.trackEvent('FIELD_IMPORT', action, errorEventString, filedCount);
    } catch (e) {
      console.log(e);
    }
  }

  controller.importNonAuthorized = $filter('nonauthorizedAction')(
    'core.assets.field'
  );

  return app.farmnetControllers.finishController(
    'fieldImportWizardController',
    $scope,
    this,
    $injector
  );
}
